(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ebw-shopping-help"] && !Shopify.designMode) return;
  try {
    function openShoppingHelp(id = window.location.hash.slice(1)) {
    if (!['ebw-shipping-help','ebw-returns-help','ebw-damaged-help'].includes(id)) return;
    const target = document.getElementById(id);
    if (target instanceof HTMLDetailsElement) {
      target.open = true;
      requestAnimationFrame(() => requestAnimationFrame(() => target.scrollIntoView({block:'start',behavior:'instant'})));
    }
  }
  window.addEventListener('hashchange',() => openShoppingHelp());
  document.addEventListener('click',event => {
    const link = event.target instanceof Element ? event.target.closest('a[href^="#ebw-"]') : null;
    if (link && ['#ebw-shipping-help','#ebw-returns-help','#ebw-damaged-help'].includes(link.getAttribute('href'))) {
      event.preventDefault();
      history.replaceState(null,'',link.getAttribute('href'));
      openShoppingHelp(link.getAttribute('href').slice(1));
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => openShoppingHelp()); else openShoppingHelp();
  } catch(e) { console.error(e); }
})();

})();
